// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting24: FC<Vetting24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m16.6 9.9-5.65 5.65L7.4 12l1.4-1.4 2.15 2.1 4.25-4.25 1.4 1.45Z" />
            <path
                d="M9.68 2.559a2.912 2.912 0 0 1 4.64 0 2.912 2.912 0 0 0 2.52 1.145l.196-.02a2.911 2.911 0 0 1 3.28 3.28l-.02.195a2.911 2.911 0 0 0 1.145 2.52 2.912 2.912 0 0 1 0 4.64l-.152.124a2.912 2.912 0 0 0-.973 2.592 2.911 2.911 0 0 1-3.102 3.3l-.178-.02a2.911 2.911 0 0 0-2.716 1.126l-.113.14a2.912 2.912 0 0 1-4.414 0l-.112-.14a2.911 2.911 0 0 0-2.716-1.125l-.179.018a2.911 2.911 0 0 1-3.12-3.12l.019-.179a2.913 2.913 0 0 0-.973-2.592l-.152-.123a2.912 2.912 0 0 1-.14-4.528l.14-.112a2.912 2.912 0 0 0 1.145-2.52l-.02-.196a2.91 2.91 0 0 1 3.28-3.28 2.912 2.912 0 0 0 2.592-.973l.124-.152Zm3.047 1.208a.912.912 0 0 0-1.453 0 4.912 4.912 0 0 1-4.582 1.898.91.91 0 0 0-1.026 1.027 4.912 4.912 0 0 1-1.898 4.582.911.911 0 0 0 0 1.452 4.912 4.912 0 0 1 1.898 4.582.91.91 0 0 0 1.026 1.026 4.912 4.912 0 0 1 4.582 1.898.912.912 0 0 0 1.453 0 4.912 4.912 0 0 1 4.582-1.898.911.911 0 0 0 1.026-1.026 4.911 4.911 0 0 1 1.898-4.582.912.912 0 0 0 0-1.452 4.911 4.911 0 0 1-1.898-4.582.911.911 0 0 0-1.026-1.027 4.912 4.912 0 0 1-4.582-1.898Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting24;
